<div class="dialog-container">
  <div class="web-close-icon">
    <button
      matTooltipPosition="above"
      data-dismiss="modal" (click)="closedialog()" class="web-close-btn">
      <span class="material-icons " style="position: relative;">clear</span>
    </button>
  </div>

  @if (screenWidth <= 480) {
    <div class="mobile-button">
      <button type="button" class="close add-close-button" style="margin: auto" data-dismiss="modal" (click)="closedialog()">
        <span class="material-icons icons-close-mobile">close</span>
      </button>
    </div>
  }
  <div class="payment-error-screen-container" [ngStyle]="{ 'padding-bottom' : screenWidth <= 480 ? '30%' : '' }">
    <div style="text-align: center;" class="payment-error-img-contianer">
      <img  style="margin: 12px auto 48px auto;background-color: white;" [src]="imagePath" class="payment-error-img">
    </div>
    <div style="background-color: white;text-align: center;" >
      <p class="title-text"  >{{HeaderTitle}}</p>
    </div>
    @if (data.limit_type == 'future_share') {
      <div >
        <p class="sub-title"> {{user?.id  == vaultStateObject?.userId ? 'No Problem! Unlock this feature when you' : 'To unlock this feature, Notify the account owner to'}}
        </p>
        @if (user?.id  == vaultStateObject?.userId ) {
          <p class="sub-title" style="color: #25508E;cursor: pointer;" (click)="openPayment()" >upgrade to Kinnect Premium</p>
        }
        @if (user?.id  != vaultStateObject?.userId ) {
          <p class="sub-title" style="color: #25508E;cursor: pointer;"  (click)="openPayment()"  >upgrade to Kinnect Premium</p>
        }
      </div>
    }
    @if (data.limit_type == 'admin_limit') {
      <div >
        @if (!ispremuimuser) {
          <p class="sub-title">You’re currently limited to {{min_admin_limit}} admins,
          </p>
        }
        @if (!ispremuimuser) {
          <p class="sub-title"  > <span style="color: #25508E;cursor:pointer" (click)="openPayment()" >Try  Kinnect Premium </span> to add up to {{max_admin_limit}}</p>
        }
        @if (ispremuimuser) {
          <p class="sub-title">
            You’re currently limited to {{admin_limit}} admins,
          </p>
        }
        @if (ispremuimuser) {
          <p class="sub-title"  >
            <a  href="https://help.kinnect.us/contacts" style="text-decoration: none;color: #25508E;"  target="_blank" >
              Contact Us
            </a>
            <span style="color: #25508E;" ></span> if you’re experiencing issues</p>
          }
        </div>
      }
      @if (data.limit_type == 'file_limit') {
        <div >
          @if (!isAdminView) {
            <p class="sub-title">   To unlock additional storage, Notify the account owner to,
            </p>
          }
          @if (!isAdminView) {
            <p  class="sub-title"  > <span style="color: #25508E;cursor: pointer;"  (click)="openPayment()" >upgrade to Kinnect Premium </span> </p>
          }
          @if (isAdminView) {
            <p class="sub-title">   You’ve reached the {{file_limit}} file limit,
            </p>
          }
          @if (isAdminView) {
            <p  class="sub-title"  > <span style="color: #25508E;cursor: pointer;"(click)="openPayment()" >Try Kinnect Premium </span>
            to add unlimited files
          </p>
        }
      </div>
    }
    @if (data.limit_type == 'storage_limit') {
      <div >
        @if (!isAdminView) {
          <p  class="sub-title" >  To unlock additional storage, Notify the account</p>
        }
        @if (!isAdminView) {
          <p  class="sub-title" >   owner to
            <span style="color: #25508E;cursor:pointer" (click)="openPayment()" >upgrade to Kinnect Premium </span>
          </p>
        }
        @if (isAdminView && data?.plan_type == 'premium') {
          <p  class="sub-title" >  You’ve reached the {{user?.premium_limits?.storage_limit}}GB limit,
          </p>
        }
        @if (isAdminView && data?.plan_type == 'premium' ) {
          <p   class="sub-title"  >
            <a  href="https://help.kinnect.us/contacts" style="text-decoration: none;color: #25508E;"  target="_blank" >
              Contact Us
            </a>
            if you’re experiencing issues
          </p>
        }
        @if (isAdminView && data?.plan_type != 'premium') {
          <p  class="sub-title" >  You’ve reached the {{user?.freemium_limits?.storage_limit}}GB limit,
          </p>
        }
        @if (isAdminView && data?.plan_type != 'premium' ) {
          <p   class="sub-title"  >
            <a  href="https://help.kinnect.us/contacts" style="text-decoration: none;color: #25508E;"  target="_blank" >
              Try Kinnect Premium
            </a>
            to add unlimited files
          </p>
        }
      </div>
    }
    @if (data.limit_type == 'security_key' && data?.plan_type == 'free' ) {
      <div >
        <p  class="sub-title">   No Problem! Unlock this feature, Notify
        </p>
        <p  class="sub-title"   >  the account owner to
          <span style="color: #25508E;cursor:pointer"  >upgrade to Kinnect Premium </span>
        </p>
      </div>
    }

    @if (data.limit_type == 'security_key' && data?.plan_type == 'premium'  ) {
      <div >
        @if (data?.plan_type == 'premium') {
          <p  class="sub-title">   To unlock this feature, Notify the account
          </p>
        }
        @if (data?.plan_type == 'premium') {
          <p
            class="sub-title"  >
            owner to
            <span  style="color: #25508E;" >Setup Security Key </span>
          </p>
        }
        @if (data?.plan_type != 'premium') {
          <p  class="sub-title">  To unlock this feature, Notify the account
          </p>
        }
        @if (data?.plan_type != 'premium') {
          <p
            class="sub-title"  >
            owner to
            <span style="color: #25508E;cursor:pointer"  >upgrade to Kinnect Premium </span>
          </p>
        }
      </div>
    }
    @if (data.limit_type == 'security_key_personal' ) {
      <div >
        <p   class="sub-title">   No Problem! Unlock this feature when you
        </p>
        <p
          class="sub-title"  >
          <span  style="color: #25508E;" (click)="openPayment()" >upgrade to Kinnect Premium </span>
        </p>
      </div>
    }

    @if (screenWidth > 480) {
      <div class="payment-error-screen-btn">
        @if (buttonTitle == buttonTextComapre) {
          <button (click)="openPayment()"  class="button-try">
            {{buttonTitle}}
          </button>
        }
        @if (buttonTitle == 'Contact Us') {
          <a  href="https://help.kinnect.us/contacts" style="padding: 12px 64px;text-decoration: none;"  target="_blank" class="button-try">
            {{buttonTitle}}
          </a>
        }
        @if (buttonTitle == 'OK') {
          <button (click)="closedialog()" class="button-try">
            {{buttonTitle}}
          </button>
        }
        @if (buttonTitle == buttonTextComapre) {
          <p class=" no-card-required" >
            No Credit Card Required
          </p>
        }
      </div>
    }


    @if (screenWidth <= 480) {
      <div class="payment-error-screen-btn  modal-footer">
        @if (buttonTitle == buttonTextComapre) {
          <button (click)="openPayment()"  class="button-try">
            {{buttonTitle}}
          </button>
        }
        @if (buttonTitle == 'Contact Us') {
          <a  href="https://help.kinnect.us/contacts" style="padding: 12px 64px;text-decoration: none;"  target="_blank" class="button-try">
            {{buttonTitle}}
          </a>
        }
        @if (buttonTitle == 'OK') {
          <button (click)="closedialog()" class="button-try">
            {{buttonTitle}}
          </button>
        }
        @if (buttonTitle == buttonTextComapre) {
          <span class="no-card-required ">
            No Credit Card Required
          </span>
        }
      </div>
    }


  </div>
